import { push } from 'react-router-redux';
import update from 'immutability-helper';
import Notifications from 'react-notification-system-redux';
import { browserHistory } from 'react-router';

import { authLoginUserFailure } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import { findByUID, findById } from '../../../core/utils';
import {
  fetchHotels,
  fetchHotel,
  fetchHotelsSearch,
  fetchSuggestedHotels,
  fetchWaitlist,
  patchHotel,
  postHotelFeatures,
  postHotelFeatures2,
  postHotelClaim,
  postWaitlist,
  postHotelAddContact,
  postHotelRemoveContact,
  postHotelEditContact,
  uploadHotelImage,
  uploadHotelDocument,
  deleteHotelPhoto,
  patchPhoto,
  postPhotoSort,
  postPropertyAccount,
  postHotel,
  HotelAddLandmark,
  postHotelAddRoomType,
  fetchBrands,
  deleteRoomPhoto,
  patchRoomDesc,
  patchLandmark,
  deleteLandmark,
  deleteRoomType,
  postAddHotelRoomPhoto,
  postAddPositionHotel,
  fetchHotelsAdvanceSearch,
  fetchHotelsAdvanceSearchWithPrefs,
  removeHotelDocument,
  updateDocument,
  fetchBrandGroups,
  fetchHotelsbyplace,
} from './api';
// ------------------------------------
// Constants
// ------------------------------------
export const HOTEL_ACCESS_FAILURE = 'HOTEL_ACCESS_FAILURE';
export const HOTEL_ACCESS_REQUEST = 'HOTEL_ACCESS_REQUEST';
export const HOTEL_ACCESS_SUCCESS = 'HOTEL_ACCESS_SUCCESS';
export const HOTEL_CONTACT_ADD_FAILURE = 'HOTEL_CONTACT_ADD_FAILURE';
export const HOTEL_CONTACT_ADD_REQUEST = 'HOTEL_CONTACT_ADD_REQUEST';
export const HOTEL_CONTACT_ADD_SUCCESS = 'HOTEL_CONTACT_ADD_SUCCESS';
export const HOTEL_CONTACT_REMOVE_FAILURE = 'HOTEL_CONTACT_REMOVE_FAILURE';
export const HOTEL_CONTACT_REMOVE_REQUEST = 'HOTEL_CONTACT_REMOVE_REQUEST';
export const HOTEL_CONTACT_REMOVE_SUCCESS = 'HOTEL_CONTACT_REMOVE_SUCCESS';
export const HOTEL_FETCH_FAILURE = 'HOTEL_FETCH_FAILURE';
export const HOTEL_FETCH_REQUEST = 'HOTEL_FETCH_REQUEST';
export const HOTEL_FETCH_SUCCESS = 'HOTEL_FETCH_SUCCESS';
export const HOTELS_FETCH_FAILURE = 'HOTELS_FETCH_FAILURE';
export const HOTELS_FETCH_REQUEST = 'HOTELS_FETCH_REQUEST';
export const HOTELS_FETCH_SUCCESS = 'HOTELS_FETCH_SUCCESS';
export const HOTEL_SUGGESTED_FETCH_FAILURE = 'HOTEL_SUGGESTED_FETCH_FAILURE';
export const HOTEL_SUGGESTED_FETCH_REQUEST = 'HOTEL_SUGGESTED_FETCH_REQUEST';
export const HOTEL_SUGGESTED_FETCH_SUCCESS = 'HOTEL_SUGGESTED_FETCH_SUCCESS';
export const HOTEL_CLAIM_FAILURE = 'HOTEL_CLAIM_FAILURE';
export const HOTEL_CLAIM_REQUEST = 'HOTEL_CLAIM_REQUEST';
export const HOTEL_CLAIM_SUCCESS = 'HOTEL_CLAIM_SUCCESS';
export const HOTEL_EDIT_FAILURE = 'HOTEL_EDIT_FAILURE';
export const HOTEL_EDIT_REQUEST = 'HOTEL_EDIT_REQUEST';
export const HOTEL_EDIT_SUCCESS = 'HOTEL_EDIT_SUCCESS';
export const HOTEL_EDIT_FEATURES_FAILURE = 'HOTEL_EDIT_FEATURES_FAILURE';
export const HOTEL_EDIT_FEATURES_REQUEST = 'HOTEL_EDIT_FEATURES_REQUEST';
export const HOTEL_EDIT_FEATURES_SUCCESS = 'HOTEL_EDIT_FEATURES_SUCCESS';
export const HOTEL_PHOTO_ADD_FAILURE = 'HOTEL_PHOTO_ADD_FAILURE';
export const HOTEL_PHOTO_ADD_REQUEST = 'HOTEL_PHOTO_ADD_REQUEST';
export const HOTEL_PHOTO_ADD_SUCCESS = 'HOTEL_PHOTO_ADD_SUCCESS';
export const HOTEL_DOCUMENT_ADD_REQUEST = 'HOTEL_DOCUMENT_ADD_REQUEST';
export const HOTEL_DOCUMENT_ADD_SUCCESS = 'HOTEL_DOCUMENT_ADD_SUCCESS';
export const HOTEL_DOCUMENT_ADD_FAILURE = 'HOTEL_DOCUMENT_ADD_FAILURE';
export const HOTEL_PHOTO_REMOVE_FAILURE = 'HOTEL_PHOTO_REMOVE_FAILURE';
export const HOTEL_PHOTO_REMOVE_REQUEST = 'HOTEL_PHOTO_REMOVE_REQUEST';
export const HOTEL_PHOTO_REMOVE_SUCCESS = 'HOTEL_PHOTO_REMOVE_SUCCESS';
export const HOTEL_PHOTO_EDIT_FAILURE = 'HOTEL_PHOTO_EDIT_FAILURE';
export const HOTEL_PHOTO_EDIT_REQUEST = 'HOTEL_PHOTO_EDIT_REQUEST';
export const HOTEL_PHOTO_EDIT_SUCCESS = 'HOTEL_PHOTO_EDIT_SUCCESS';
export const HOTEL_PHOTO_SORT_FAILURE = 'HOTEL_PHOTO_SORT_FAILURE';
export const HOTEL_PHOTO_SORT_REQUEST = 'HOTEL_PHOTO_SORT_REQUEST';
export const HOTEL_PHOTO_SORT_SUCCESS = 'HOTEL_PHOTO_SORT_SUCCESS';
export const PROPERTY_ACCOUNT_REGISTER_FAILURE = 'PROPERTY_ACCOUNT_REGISTER_FAILURE';
export const PROPERTY_ACCOUNT_REGISTER_REQUEST = 'PROPERTY_ACCOUNT_REGISTER_REQUEST';
export const PROPERTY_ACCOUNT_REGISTER_SUCCESS = 'PROPERTY_ACCOUNT_REGISTER_SUCCESS';

export const HOTEL_SEARCH_FAILURE = 'HOTEL_SEARCH_FAILURE';
export const HOTEL_SEARCH_REQUEST = 'HOTEL_SEARCH_REQUEST';
export const HOTEL_SEARCH_SUCCESS = 'HOTEL_SEARCH_SUCCESS';

export const BRAND_FETCH_FAILURE = 'BRAND_FETCH_FAILURE';
export const BRAND_FETCH_REQUEST = 'BRAND_FETCH_REQUEST';
export const BRAND_FETCH_SUCCESS = 'BRAND_FETCH_SUCCESS';

export const ROOMTYPE_EDIT_SUCCESS = 'ROOMTYPE_EDIT_SUCCESS';
export const ROOMTYPE_EDIT_REQUEST = 'ROOMTYPE_EDIT_REQUEST';
export const ROOMTYPE_EDIT_FAILURE = 'ROOMTYPE_EDIT_FAILURE';

export const ROOMTYPE_ADD_SUCCESS = 'ROOMTYPE_ADD_SUCCESS';
export const ROOMTYPE_ADD_REQUEST = 'ROOMTYPE_ADD_REQUEST';
export const ROOMTYPE_ADD_FAILURE = 'ROOMTYPE_ADD_FAILURE';

export const ROOMTYPE_REMOVE_SUCCESS = 'ROOMTYPE_REMOVE_SUCCESS';
export const ROOMTYPE_REMOVE_REQUEST = 'ROOMTYPE_REMOVE_REQUEST';
export const ROOMTYPE_REMOVE_FAILURE = 'ROOMTYPE_REMOVE_FAILURE';


export const ROOM_PHOTO_REMOVE_SUCCESS = 'ROOM_PHOTO_REMOVE_SUCCESS';
export const ROOM_PHOTO_REMOVE_REQUEST = 'ROOM_PHOTO_REMOVE_REQUEST';
export const ROOM_PHOTO_REMOVE_FAILURE = 'ROOM_PHOTO_REMOVE_FAILURE';

export const LANDMARK_EDIT_SUCCESS = 'LANDMARK_EDIT_SUCCESS';
export const LANDMARK_EDIT_REQUEST = 'LANDMARK_EDIT_REQUEST';
export const LANDMARK_EDIT_FAILURE = 'LANDMARK_EDIT_FAILURE';

export const LANDMARK_REMOVE_SUCCESS = 'LANDMARK_REMOVE_SUCCESS';
export const LANDMARK_REMOVE_REQUEST = 'LANDMARK_REMOVE_REQUEST';
export const LANDMARK_REMOVE_FAILURE = 'LANDMARK_REMOVE_FAILURE';


export const ROOM_PHOTO_ADD_SUCCESS = 'ROOM_PHOTO_ADD_SUCCESS';
export const ROOM_PHOTO_ADD_REQUEST = 'ROOM_PHOTO_ADD_REQUEST';
export const ROOM_PHOTO_ADD_FAILURE = 'ROOM_PHOTO_ADD_FAILURE';


export const LANDMARK_ADD_SUCCESS = 'LANDMARK_ADD_SUCCESS';
export const LANDMARK_ADD_REQUEST = 'LANDMARK_ADD_REQUEST';
export const LANDMARK_ADD_FAILURE = 'LANDMARK_ADD_FAILURE';

export const HOTEL_ADD_FAILURE = 'HOTEL_ADD_FAILURE';
export const HOTEL_ADD_REQUEST = 'HOTEL_ADD_REQUEST';
export const HOTEL_ADD_SUCCESS = 'HOTEL_ADD_SUCCESS';

export const HOTEL_ADVANCE_SEARCH_REQUEST = 'HOTEL_ADVANCE_SEARCH_REQUEST';
export const HOTEL_ADVANCE_SEARCH_SUCCESS = 'HOTEL_ADVANCE_SEARCH_SUCCESS';
export const HOTEL_ADVANCE_SEARCH_FAILURE = 'HOTEL_ADVANCE_SEARCH_FAILURE';

export const HOTEL_ADVANCE_SEARCH_WITH_PREFS_REQUEST = 'HOTEL_ADVANCE_SEARCH_WITH_PREFS_REQUEST';
export const HOTEL_ADVANCE_SEARCH_WITH_PREFS_SUCCESS = 'HOTEL_ADVANCE_SEARCH_WITH_PREFS_SUCCESS';
export const HOTEL_ADVANCE_SEARCH_WITH_PREFS_FAILURE = 'HOTEL_ADVANCE_SEARCH_WITH_PREFS_FAILURE';

export const BRAND_GROUP_FETCH_REQUEST = 'BRAND_GROUP_FETCH_REQUEST';
export const BRAND_GROUP_FETCH_SUCCESS = 'BRAND_GROUP_FETCH_SUCCESS';

export const HOTEL_DOCUMENT_DELETE_REQUEST = 'HOTEL_DOCUMENT_DELETE_REQUEST';
export const HOTEL_DOCUMENT_DELETE_SUCCESS = 'HOTEL_DOCUMENT_DELETE_SUCCESS';
export const HOTEL_DOCUMENT_DELETE_FAILURE = 'HOTEL_DOCUMENT_DELETE_FAILURE';

export const HOTEL_DOCUMENT_UPDATE_REQUEST = 'HOTEL_DOCUMENT_UPDATE_REQUEST';
export const HOTEL_DOCUMENT_UPDATE_SUCCESS = 'HOTEL_DOCUMENT_UPDATE_SUCCESS';
export const HOTEL_DOCUMENT_UPDATE_FAILURE = 'HOTEL_DOCUMENT_UPDATE_FAILURE';



// ------------------------------------
// Actions
// ------------------------------------
export function viewBrowseHotel(id) {
  browserHistory.push(`/browse/hotels/${id}`);
}
export function viewHotel(id) {
  browserHistory.push(`/hotels/${id}`);
}

export function hotelAccessRequest() {
  return {
    type: HOTEL_ACCESS_REQUEST,
    payload: null,
  };
}
export function hotelAccessSuccess(json) {
  return {
    type: HOTEL_ACCESS_SUCCESS,
    payload: json.onlist,
  };
}
export function hotelAccessFailure(json) {
  return {
    type: HOTEL_ACCESS_FAILURE,
    payload: json,
  };
}
export function hotelFetchRequest() {
  return {
    type: HOTEL_FETCH_REQUEST,
    payload: null,
  };
}
export function hotelFetchSuccess(json) {
  return {
    type: HOTEL_FETCH_SUCCESS,
    payload: json,
  };
}
export function hotelFetchFailure(json) {
  return {
    type: HOTEL_FETCH_FAILURE,
    payload: json,
  };
}
export function hotelsFetchRequest() {
  return {
    type: HOTELS_FETCH_REQUEST,
    payload: null,
  };
}
export function hotelsFetchSuccess(json) {
  return {
    type: HOTELS_FETCH_SUCCESS,
    payload: json,
  };
}
export function hotelsFetchFailure(json) {
  return {
    type: HOTELS_FETCH_FAILURE,
    payload: json,
  };
}
export function hotelSuggestedFetchRequest() {
  return {
    type: HOTEL_SUGGESTED_FETCH_REQUEST,
    payload: null,
  };
}
export function hotelSuggestedFetchSuccess(json) {
  return {
    type: HOTEL_SUGGESTED_FETCH_SUCCESS,
    payload: json,
  };
}
export function hotelSuggestedFetchFailure(json) {
  return {
    type: HOTEL_SUGGESTED_FETCH_FAILURE,
    payload: json,
  };
}
export function hotelClaimRequest() {
  return {
    type: HOTEL_CLAIM_REQUEST,
    payload: null,
  };
}
export function hotelClaimSuccess(json) {
  return {
    type: HOTEL_CLAIM_SUCCESS,
    payload: json,
  };
}
export function hotelClaimFailure(json) {
  return {
    type: HOTEL_CLAIM_FAILURE,
    payload: json,
  };
}

export function hotelEditRequest() {
  return {
    type: HOTEL_EDIT_REQUEST,
    payload: null,
  };
}
export function roomtypeEditRequest() {
  return {
    type: ROOMTYPE_EDIT_REQUEST,
    payload: null,
  };
}
export function roomTypeAddRequest() {
  return {
    type: ROOMTYPE_ADD_REQUEST,
    payload: null,
  };
}
export function roomTypeAddSuccess(json) {
  return {
    type: ROOMTYPE_ADD_SUCCESS,
    payload: json,
  };
}

export function roomPhotoAddRequest() {
  return {
    type: ROOM_PHOTO_ADD_REQUEST,
    payload: null,
  };
}

export function roomPhotoAddSuccess(json) {
  return {
    type: ROOM_PHOTO_ADD_SUCCESS,
    payload: json,
  };
}




export function hotelEditSuccess(json) {
  return {
    type: HOTEL_EDIT_SUCCESS,
    payload: json,
  };
}

export function hotelAddSuccess(json) {
  return {
    type: HOTEL_ADD_SUCCESS,
    payload: json,
  };
}
export function roomtypeEditSuccess(json) {
  return {
    type: ROOMTYPE_EDIT_SUCCESS,
    payload: json,
  };
}
export function landmarkEditSuccess(json) {
  return {
    type: LANDMARK_EDIT_SUCCESS,
    payload: json,
  };
}
export function landmarkEditRequest() {
  return {
    type: LANDMARK_EDIT_REQUEST,
    payload: null,
  };
}
export function hotelEditFailure(json) {
  return {
    type: HOTEL_EDIT_FAILURE,
    payload: json,
  };
}
export function hotelAddFailure(json) {
  return {
    type: HOTEL_ADD_FAILURE,
    payload: json,
  };
}
export function hotelEditFeaturesRequest(json) {
  return {
    type: HOTEL_EDIT_FEATURES_REQUEST,
    payload: json,
  };
}
export function hotelContactAddRequest(json) {
  return {
    type: HOTEL_CONTACT_ADD_REQUEST,
    payload: json,
  };
}
export function hotelContactAddFailure(json) {
  return {
    type: HOTEL_CONTACT_ADD_FAILURE,
    payload: json,
  };
}
export function hotelContactAddSuccess(json) {
  return {
    type: HOTEL_CONTACT_ADD_SUCCESS,
    payload: json,
  };
}
export function hotelContactRemoveRequest(json) {
  return {
    type: HOTEL_CONTACT_REMOVE_REQUEST,
    payload: json,
  };
}
export function hotelContactRemoveFailure(json) {
  return {
    type: HOTEL_CONTACT_REMOVE_FAILURE,
    payload: json,
  };
}
export function hotelContactRemoveSuccess(json) {
  return {
    type: HOTEL_CONTACT_REMOVE_SUCCESS,
    payload: json,
  };
}
export function hotelPhotoAddRequest(json) {
  return {
    type: HOTEL_PHOTO_ADD_REQUEST,
    payload: json,
  };
}
export function hotelPhotoAddFailure(json) {
  return {
    type: HOTEL_PHOTO_ADD_FAILURE,
    payload: json,
  };
}
export function hotelPhotoAddSuccess(json) {
  return {
    type: HOTEL_PHOTO_ADD_SUCCESS,
    payload: json,
  };
}
export function hotelDocumentAddRequest(json) {
  return {
    type: HOTEL_DOCUMENT_ADD_REQUEST,
    payload: json,
  };
}
export function hotelDocumentAddFailure(json) {
  return {
    type: HOTEL_DOCUMENT_ADD_FAILURE,
    payload: json,
  };
}
export function hotelDocumentAddSuccess(json) {
  return {
    type: HOTEL_DOCUMENT_ADD_SUCCESS,
    payload: json,
  };
}
export function hotelPhotoRemoveRequest(json) {
  return {
    type: HOTEL_PHOTO_REMOVE_REQUEST,
    payload: json,
  };
}
export function hotelPhotoRemoveFailure(json) {
  return {
    type: HOTEL_PHOTO_REMOVE_FAILURE,
    payload: json,
  };
}
export function hotelPhotoRemoveSuccess(json) {
  return {
    type: HOTEL_PHOTO_REMOVE_SUCCESS,
    payload: json,
  };
}
export function roomTypeRemoveSuccess(json) {
  return {
    type: ROOMTYPE_REMOVE_SUCCESS,
    payload: json,
  };
}
export function roomTypeRemoveRequest(json) {
  return {
    type: ROOMTYPE_REMOVE_REQUEST,
    payload: null,
  };
}


export function roomPhotoRemoveSuccess(json) {
  return {
    type: ROOM_PHOTO_REMOVE_SUCCESS,
    payload: json,
  };
}
export function roomPhotoRemoveRequest(json) {
  return {
    type: ROOM_PHOTO_REMOVE_REQUEST,
    payload: json,
  };
}



export function landmarkRemoveSuccess(json) {
  return {
    type: LANDMARK_REMOVE_SUCCESS,
    payload: json,
  };
}
export function LandmarkRemoveRequest(json) {
  return {
    type: LANDMARK_REMOVE_REQUEST,
    payload: json,
  };
}
export function LandmarkAddRequest(json) {
  return {
    type: LANDMARK_ADD_REQUEST,
    payload: json,
  };
}
export function LandmarkAddSuccess(json) {
  return {
    type: LANDMARK_ADD_SUCCESS,
    payload: json,
  };
}
export function hotelPhotoEditRequest(json) {
  return {
    type: HOTEL_PHOTO_EDIT_REQUEST,
    payload: json,
  };
}
export function hotelPhotoEditFailure(json) {
  return {
    type: HOTEL_PHOTO_EDIT_FAILURE,
    payload: json,
  };
}
export function hotelPhotoEditSuccess(json) {
  return {
    type: HOTEL_PHOTO_EDIT_SUCCESS,
    payload: json,
  };
}
export function hotelPhotoSortRequest(json) {
  return {
    type: HOTEL_PHOTO_SORT_REQUEST,
    payload: json,
  };
}
export function hotelPhotoSortFailure(json) {
  return {
    type: HOTEL_PHOTO_SORT_FAILURE,
    payload: json,
  };
}
export function hotelPhotoSortSuccess(json) {
  return {
    type: HOTEL_PHOTO_SORT_SUCCESS,
    payload: json,
  };
}
export function hotelSearchRequest() {
  return {
    type: HOTEL_SEARCH_REQUEST,
    payload: null,
  };
}
export function hotelSearchSuccess(json) {
  return {
    type: HOTEL_SEARCH_SUCCESS,
    payload: json,
  };
}
export function hotelSearchFailure(json) {
  return {
    type: HOTEL_SEARCH_FAILURE,
    payload: json,
  };
}
export function hotelAdvanceSearchRequest() {
  return {
    type: HOTEL_ADVANCE_SEARCH_REQUEST,
    payload: null,
  };
}
export function hotelAdvanceSearchSuccess(json) {
  return {
    type: HOTEL_ADVANCE_SEARCH_SUCCESS,
    payload: json,
  };
}
export function hotelAdvanceSearchFailure(json) {
  return {
    type: HOTEL_ADVANCE_SEARCH_FAILURE,
    payload: json,
  };
}
export function hotelAdvanceSearchWithPrefsRequest() {
  return {
    type: HOTEL_ADVANCE_SEARCH_WITH_PREFS_REQUEST,
    payload: null,
  };
}
export function hotelAdvanceSearchWithPrefsSuccess(json) {
  return {
    type: HOTEL_ADVANCE_SEARCH_WITH_PREFS_SUCCESS,
    payload: json,
  };
}
export function hotelAdvanceSearchWithPrefsFailure(json) {
  return {
    type: HOTEL_ADVANCE_SEARCH_WITH_PREFS_FAILURE,
    payload: json,
  };
}
export function propertyAccountRegisterRequest() {
  return {
    type: PROPERTY_ACCOUNT_REGISTER_REQUEST,
    payload: null,
  };
}
export function propertyAccountRegisterSuccess() {
  return {
    type: PROPERTY_ACCOUNT_REGISTER_SUCCESS,
    payload: null,
  };
}
export function propertyAccountRegisterFailure(json) {
  return {
    type: PROPERTY_ACCOUNT_REGISTER_FAILURE,
    payload: json,
  };
}
export function requestingBrands() {
  return {
    type: BRAND_FETCH_REQUEST,
    payload: null,
  };
}
export function receiveBrands(json) {
  return {
    type: BRAND_FETCH_SUCCESS,
    payload: json,
  };
}
export function requestingBrandGroups() {
  return {
    type: BRAND_GROUP_FETCH_REQUEST,
    payload: null,
  };
}

export function receiveBrandGroups(json) {
  return {
    type: BRAND_GROUP_FETCH_SUCCESS,
    payload: json,
  };
}
export function hotelDocumentDeleteRequest(json) {
  return {
    type: HOTEL_DOCUMENT_DELETE_REQUEST,
    payload: json,
  };
}
export function hotelDocumentDeleteFailure(json) {
  return {
    type: HOTEL_DOCUMENT_DELETE_FAILURE,
    payload: json,
  };
}
export function hotelDocumentDeleteSuccess(json) {
  return {
    type: HOTEL_DOCUMENT_DELETE_SUCCESS,
    payload: json,
  };
}
export function hotelDocumentUpdateRequest(json) {
  return {
    type: HOTEL_DOCUMENT_UPDATE_REQUEST,
    payload: json,
  };
}
export function hotelDocumentUpdateFailure(json) {
  return {
    type: HOTEL_DOCUMENT_UPDATE_FAILURE,
    payload: json,
  };
}
export function hotelDocumentUpdateSuccess(json) {
  return {
    type: HOTEL_DOCUMENT_UPDATE_SUCCESS,
    payload: json,
  };
}

export function hotelByPlaceResquest(){
  return {
    type: HOTEL_ADVANCE_SEARCH_WITH_PREFS_REQUEST,
    payload: null,
  };
}

export function hotelByPlaceSuccess(json){
  return {
    type: HOTEL_ADVANCE_SEARCH_WITH_PREFS_SUCCESS,
    payload: json,
  };
}
function formatBrandData(jsonObject) {
  return jsonObject.map(item => ({
    label: item.name,
    value: item.id,
  }));
}

export function checkWaitlist() {
  return dispatch => {
    dispatch(hotelAccessRequest());
    return fetchWaitlist()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelAccessSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelAccessFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(checkWaitlist()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(checkWaitlist()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelAccessFailure({}));
      });
  };
}

export function joinWaitlist() {
  return dispatch => {
    dispatch(hotelAccessRequest());
    return postWaitlist({})
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelAccessSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelAccessFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(joinWaitlist()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(joinWaitlist()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelAccessFailure({}));
      });
  };
}
export function registerPropertyAccount(payload) {
  return dispatch => {
    dispatch(propertyAccountRegisterRequest());
    return postPropertyAccount(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(propertyAccountRegisterSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(propertyAccountRegisterFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(joinWaitlist()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(joinWaitlist()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(propertyAccountRegisterFailure({}));
      });
  };
}

export function requestHotelSearch(payload, hasSearchPrefs, cb) {
  return dispatch => {
    dispatch(hotelSearchRequest(payload));
    return fetchHotelsSearch(payload, hasSearchPrefs)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelSearchSuccess(response));
        cb(response);
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelSearchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestHotelSearch(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotelSearch(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelSearchFailure(payload));
      });
  };
}
export function requestBrandGroups() {  
  return (dispatch) => {  
    dispatch(requestingBrandGroups());  
    return fetchBrandGroups() 
      .then(checkHttpStatus)  
      .then(parseJSON)  
      .then((response) => { 
        dispatch(receiveBrandGroups(response)); 
      })  
      .catch((error) => { 
        if (error && typeof error.response !== 'undefined') { 
          const status = error.response.status; 
          if (status >= 401 && status <= 403) { 
            // Invalid authentication credentials 
            return error.response.json().then((detail) => { 
              dispatch(authLoginUserFailure(status, detail)); 
              dispatch(push(`/login?next=${this.props.location.pathname}`));  
            }); 
          } 
          if (status === 400) { 
            error.response.json().then((detail) => {  
              console.log('400: ', detail); 
            }); 
          } else if (status >= 404) { 
            console.log('Yikes problem with server. ', status); 
          } 
        } else {  
          // Most likely connection issues  
          console.log('An error occurred while sending your data!');  
        } 
      }); 
  };  
}
export function requestHotelAdvanceSearch(payload, cb) {
  return dispatch => {
    dispatch(hotelAdvanceSearchRequest(payload));
    return fetchHotelsAdvanceSearch(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelAdvanceSearchSuccess(response));
        cb(response);
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelAdvanceSearchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestHotelAdvanceSearch(payload, cb)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotelAdvanceSearch(payload, cb)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelAdvanceSearchFailure(payload));
      });
  };
}
export function requestHotelByPlaces(payload,cb){
  return dispatch=>{
    dispatch(hotelByPlaceResquest(payload));
    return fetchHotelsbyplace(payload)
    .then(checkHttpStatus)
    .then(parseJSON)
    .then(response => {
      dispatch(hotelByPlaceSuccess(response));
      cb(response)
    })
    .catch(error => {
      if (error && typeof error.response !== 'undefined') {
        const status = error.response.status;
        if (status === 400) {
          error.response.json().then(detail => {
            dispatch(hotelAdvanceSearchWithPrefsFailure(detail));
          });
        } else if (status >= 401 && status <= 403) {
          // Invalid authentication credentials
          return error.response.json().then(detail => {
            dispatch(authLoginUserFailure(status, detail));
            // const redirectAfterLogin = this.props.location.pathname;
            dispatch(push('/login'));
          });
        } else if (status >= 404) {
          console.log('Yikes problem with server. ', status);
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotelAdvanceSearchWithPrefs(payload, cb)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
      } else {
        // Most likely connection issues
        console.log('An error occurred while sending your data!');
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Yikes!',
          message: 'We can not connect to the server. Try again in a bit.',
          autoDismiss: 0,
          action: {
            label: 'Retry',
            callback: () => dispatch(requestHotelAdvanceSearchWithPrefs(payload, cb)),
          },
        };
        dispatch(Notifications.error(notificationOpts));
      }
      return dispatch(hotelAdvanceSearchWithPrefsFailure(payload));
    });
  }
}

export function requestHotelAdvanceSearchWithPrefs(payload, cb) {
  return dispatch => {
    dispatch(hotelAdvanceSearchWithPrefsRequest(payload));
    return fetchHotelsAdvanceSearchWithPrefs(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelAdvanceSearchWithPrefsSuccess(response));
        cb(response);
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelAdvanceSearchWithPrefsFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestHotelAdvanceSearchWithPrefs(payload, cb)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotelAdvanceSearchWithPrefs(payload, cb)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelAdvanceSearchWithPrefsFailure(payload));
      });
  };
}

export function requestHotelClaim(id, payload) {
  return dispatch => {
    dispatch(hotelClaimRequest(id));
    return postHotelClaim(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Congrats!',
          message: 'You are ready to manage your hotel',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelClaimSuccess(response));
        dispatch(push(`/hotels/${id}`));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelClaimFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestHotelClaim(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotelClaim(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelClaimFailure(payload));
      });
  };
}
export function editHotel(id, payload) {
  return dispatch => {
    dispatch(hotelEditRequest(id));
    return patchHotel(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        if(payload.isPosition){
        postAddPositionHotel(id,payload)
          .then(checkHttpStatus)
          .then(parseJSON)
          .then(response2 => {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Congrats!',
              message: 'Hotel updated.',
              autoDismiss: 15,
            };
            dispatch(Notifications.success(notificationOpts));
            dispatch(hotelEditSuccess(response));
          })
        }else{
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Congrats!',
            message: 'Hotel updated.',
            autoDismiss: 15,
          };
          dispatch(Notifications.success(notificationOpts));
          dispatch(hotelEditSuccess(response));
        }
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editHotel(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editHotel(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelEditFailure(payload));
      });
  };
}

export function editLandmark(id, payload) {
  return dispatch => {
    dispatch(landmarkEditRequest(id));
    return patchLandmark(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Congrats!',
          message: 'Landmark updated.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(landmarkEditSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editHotel(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editHotel(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelEditFailure(payload));
      });
  };
}


export function editRoomtypes(id, payload) {
  return dispatch => {
    dispatch(roomtypeEditRequest(id));
    return patchRoomDesc(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Congrats!',
          message: 'Room description updated.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(roomtypeEditSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editHotel(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editHotel(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelEditFailure(payload));
      });
  };
}

export function addHotel(payload) {
  return dispatch => {
    return postHotel(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        postAddPositionHotel(response.id,payload)
          .then(checkHttpStatus)
          .then(parseJSON)
          .then(response2 => {
            const notificationOpts = {
              title: 'Congrats!',
              message: 'Hotel added successfully.',
              autoDismiss: 15,
            };
            dispatch(Notifications.success(notificationOpts));
            dispatch(hotelAddSuccess(response));
            dispatch(push(`/hotels/${response.id}`));
          })
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelAddFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(addHotel(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(addHotel(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelAddFailure(payload));
      });
  };
}


// export function addHotel(payload) {
//   return dispatch => {
//     return postHotel(payload)
//       .then(checkHttpStatus)
//       .then(parseJSON)
//       .then(response => {
//         let resp = response.id
//         postHotelFeatures(resp, payload.features)
//           .then(checkHttpStatus)
//           .then(parseJSON)
//           .then(response => {
//             postHotelAddRoomType(resp, payload.roomData)
//               .then(checkHttpStatus)
//               .then(parseJSON)
//               .then(response => {
//                 postHotelAddLandmark(resp, payload.landmarkData)
//                   .then(checkHttpStatus)
//                   .then(parseJSON)
//                   .then(response => {
//                     postHotelAddContact(resp, payload.contactData)
//                       .then(checkHttpStatus)
//                       .then(parseJSON)
//                       .then(response => {
//                         const notificationOpts = {
//                           title: 'Congrats!',
//                           message: 'Hotel added successfully.',
//                           autoDismiss: 15,
//                         };
//                         dispatch(Notifications.success(notificationOpts));
//                         dispatch(hotelEditSuccess(response));
//                       })
//                   })
//               })
//           })

//       })
//       .catch(error => {
//         if (error && typeof error.response !== 'undefined') {
//           const status = error.response.status;
//           if (status === 400) {
//             error.response.json().then(detail => {
//               dispatch(hotelEditFailure(detail));
//             });
//           } else if (status >= 401 && status <= 403) {
//             // Invalid authentication credentials
//             return error.response.json().then(detail => {
//               dispatch(authLoginUserFailure(status, detail));
//               // const redirectAfterLogin = this.props.location.pathname;
//               dispatch(push('/login'));
//             });
//           } else if (status >= 404) {
//             console.log('Yikes problem with server. ', status);
//             const notificationOpts = {
//               // uid: 'once-please', // you can specify your own uid if required
//               title: 'Yikes!',
//               message: 'Ugh. Something is wrong. Try again in a bit.',
//               autoDismiss: 0,
//               action: {
//                 label: 'Retry',
//                 callback: () => dispatch(editHotel(id, payload)),
//               },
//             };
//             dispatch(Notifications.error(notificationOpts));
//           }
//         } else {
//           // Most likely connection issues
//           console.log('An error occurred while sending your data!');
//           const notificationOpts = {
//             // uid: 'once-please', // you can specify your own uid if required
//             title: 'Yikes!',
//             message: 'We can not connect to the server. Try again in a bit.',
//             autoDismiss: 0,
//             action: {
//               label: 'Retry',
//               callback: () => dispatch(editHotel(id, payload)),
//             },
//           };
//           dispatch(Notifications.error(notificationOpts));
//         }
//         return dispatch(hotelEditFailure(payload));
//       });
//   };
// }

export function requestBrandOptions() {
  return dispatch => {
    dispatch(requestingBrands());
    return fetchBrands()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveBrands(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=${this.props.location.pathname}`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}


export function editHotelFeatures(id, payload) {
  return dispatch => {
    dispatch(hotelEditFeaturesRequest(id));
    return postHotelFeatures(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Congrats!',
          message: 'Hotel Amenities Updated.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelEditSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editHotel(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editHotel(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelEditFailure(payload));
      });
  };
}
export function addHotelContact(id, payload) {
  return dispatch => {
    dispatch(hotelContactRemoveRequest(payload));
    return postHotelAddContact(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Congrats!',
          message: 'Hotel contact added.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelContactAddSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelContactAddFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(addHotelContact(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(addHotelContact(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelContactAddFailure(payload));
      });
  };
}
export function removeHotelContact(id, payload) {
  return dispatch => {
    dispatch(hotelContactRemoveRequest(payload));
    return postHotelRemoveContact(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Contact',
          message: 'Hotel contact removed.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelContactRemoveSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelContactRemoveFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeHotelContact(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeHotelContact(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelContactRemoveFailure(payload));
      });
  };
}


export function editHotelContact(id, payload) {
  return dispatch => {
    dispatch(hotelContactRemoveRequest(payload));
    return postHotelEditContact(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Congrats!',
          message: 'Hotel contact updated.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelContactAddSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelContactAddFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(addHotelContact(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(addHotelContact(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelContactAddFailure(payload));
      });
  };
}
export function addHotelPhoto(payload) {
  return dispatch => {
    dispatch(hotelPhotoAddRequest(payload));
    return uploadHotelImage(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Updated',
          message: 'New photo added.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelPhotoAddSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoAddFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(addHotelPhoto(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(addHotelPhoto(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoAddFailure(payload));
      });
  };
}
export function addHotelDocument(id, payload) {
  return dispatch => {
    dispatch(hotelDocumentAddRequest(payload));
    return uploadHotelDocument(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Updated',
          message: 'New Document added.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelDocumentAddSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelDocumentAddFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(addHotelDocument(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(addHotelDocument(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelDocumentAddFailure(payload));
      });
  };
}
export function updateHotelDocument(id, payload, cb) {
  return dispatch => {
    dispatch(hotelDocumentUpdateRequest(payload));
    return updateDocument(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Document Updated',
          message: 'hotel document updated.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelDocumentUpdateSuccess(response));
        cb(response)
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelDocumentUpdateFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(updateHotelDocument(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(updateHotelDocument(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelDocumentUpdateFailure(payload));
      });
  };
}
export function deleteHotelDocument(id, payload) {
  return dispatch => {
    dispatch(hotelDocumentDeleteRequest(payload));
    return removeHotelDocument(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Document Deleted',
          message: 'Hotel Document deleted.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelDocumentDeleteSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelDocumentDeleteFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(deleteHotelDocument(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(deleteHotelDocument(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelDocumentDeleteFailure(payload));
      });
  };
}
export function removeHotelPhoto(id, payload) {
  return dispatch => {
    dispatch(hotelPhotoRemoveRequest(payload));
    return deleteHotelPhoto(id)
      .then(checkHttpStatus)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Updated',
          message: 'Photo removed.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(hotelPhotoRemoveSuccess({ id, response }));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoRemoveFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeHotelPhoto(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeHotelPhoto(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoAddFailure(payload));
      });
  };
}


export function removeRoomType(id, payload) {
  return dispatch => {
    dispatch(roomTypeRemoveRequest());
    return deleteRoomType(id)
      .then(checkHttpStatus)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Updated',
          message: 'Room removed.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(roomTypeRemoveSuccess({ id, response }));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoRemoveFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeHotelPhoto(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeHotelPhoto(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoAddFailure(payload));
      });
  };
}

export function removeRoomPhoto(id, room_type_id) {
  return dispatch => {
    dispatch(roomPhotoRemoveRequest(id));
    return deleteRoomPhoto(id)
      .then(checkHttpStatus)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Updated',
          message: 'Room Photo removed.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(roomPhotoRemoveSuccess({ id, room_type_id }));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoRemoveFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeHotelPhoto(id)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeRoomPhoto(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoAddFailure(payload));
      });
  };
}
export function removeLandmark(id, payload) {
  return dispatch => {
    dispatch(LandmarkRemoveRequest(payload));
    return deleteLandmark(id)
      .then(checkHttpStatus)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Updated',
          message: 'Landmark removed.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(landmarkRemoveSuccess({ id, response }));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoRemoveFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeLandmark(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeHotelPhoto(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoAddFailure(payload));
      });
  };
}

export function postHotelAddLandmark(id, payload) {
  return dispatch => {
    dispatch(LandmarkAddRequest(payload));
    return HotelAddLandmark(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Updated',
          message: 'Landmark Added.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(LandmarkAddSuccess({ response }));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoRemoveFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeHotelPhoto(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeHotelPhoto(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoAddFailure(payload));
      });
  };
}


// postAddHotelRoomPhoto


export function addAddHotelRoomPhoto(payload) {
  return dispatch => {
    dispatch(roomPhotoAddRequest(payload));
    return postAddHotelRoomPhoto(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Hotel Updated',
          message: 'Room Photo Added.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(roomPhotoAddSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoRemoveFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeHotelPhoto(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeHotelPhoto(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoAddFailure(payload));
      });
  };
}

export function addHotelAddRoomType(payload, cb) {
  return dispatch => {
    dispatch(roomTypeAddRequest(payload));
    return postHotelAddRoomType(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          title: 'Hotel Updated',
          message: 'Room Type Added.',
          autoDismiss: 15,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(roomTypeAddSuccess(response));
        cb(response)
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoRemoveFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(addHotelAddRoomType(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeHotelPhoto(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoAddFailure(payload));
      });
  };
}

export function editHotelPhoto(id, payload) {
  return dispatch => {
    dispatch(hotelPhotoEditRequest(payload));
    return patchPhoto(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelPhotoEditSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editHotelPhoto(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editHotelPhoto(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoEditFailure(payload));
      });
  };
}
export function sortHotelPhotos(id, payload) {
  return dispatch => {
    dispatch(hotelPhotoSortRequest(payload));
    return postPhotoSort(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelPhotoSortSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelPhotoSortFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(sortHotelPhotos(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(sortHotelPhotos(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelPhotoSortFailure(payload));
      });
  };
}

export function requestHotel(id) {
  return dispatch => {
    dispatch(hotelFetchRequest());
    return fetchHotel(id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        //debugger
        dispatch(hotelFetchSuccess(response));
      })
      .catch(error => {
        //debugger
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelFetchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestHotel(id)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotel(id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelFetchFailure());
      });
  };
}
export function requestHotels() {
  return dispatch => {
    dispatch(hotelsFetchRequest());
    return fetchHotels()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelsFetchSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
              dispatch(hotelsFetchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestHotels()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotels()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelsFetchFailure());
      });
  };
}

export function requestSuggestedHotels() {
  return dispatch => {
    dispatch(hotelSuggestedFetchRequest());
    return fetchSuggestedHotels()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(hotelSuggestedFetchSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(hotelSuggestedFetchFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestHotels()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestHotels()),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(hotelSuggestedFetchFailure());
      });
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [HOTEL_ACCESS_REQUEST]: (state, action) => {
    return update(state, {
      waitlist: {
        $merge: {
          needFetch: false,
          isFetching: true,
        },
      },
    });
  },
  [BRAND_FETCH_SUCCESS]: (state, action) =>
    update(state, { brands: { $set: formatBrandData(action.payload) } }),

  [HOTEL_ACCESS_SUCCESS]: (state, action) => {
    return update(state, {
      waitlist: {
        $merge: {
          needFetch: false,
          isFetching: false,
          onWaitlist: action.payload,
        },
      },
    });
  },

  [HOTEL_FETCH_REQUEST]: (state, action) => {
    return update(state, {
      selectedHotel: {
        $merge: {
          needFetch: false,
          isFetching: true,
        },
      },
    });
  },
  [HOTEL_FETCH_SUCCESS]: (state, action) => {
    return update(state, {
      selectedHotel: {
        $merge: {
          isFetching: false,
          hotel: action.payload,
        },
      },
    });
  },
  [HOTELS_FETCH_REQUEST]: (state, action) => {
    return update(state, {
      $merge: {
        needFetch: false,
        isFetching: true,
      },
    });
  },
  [HOTELS_FETCH_SUCCESS]: (state, action) => {
    return update(state, {
      $merge: {
        isFetching: false,
        hotels: action.payload.results,
      },
    });
  },
  [HOTEL_SUGGESTED_FETCH_REQUEST]: (state, action) => {
    return update(state, {
      suggested: {
        $merge: {
          needFetch: false,
          isFetching: true,
        },
      },
    });
  },
  [HOTEL_SUGGESTED_FETCH_SUCCESS]: (state, action) => {
    return update(state, {
      suggested: {
        $merge: {
          isFetching: false,
          hotels: action.payload.results,
        },
      },
    });
  },
  [HOTEL_SEARCH_REQUEST]: (state, action) => {
    return update(state, {
      search: {
        $merge: {
          needFetch: false,
          isFetching: true,
          hotels: [],
        },
      },
    });
  },
  [HOTEL_SEARCH_SUCCESS]: (state, action) => {
    return update(state, {
      search: {
        $merge: {
          isFetching: false,
          hotels: action.payload.results,
        },
      },
    });
  },
  [HOTEL_CLAIM_SUCCESS]: (state, action) => {
    const id = action.payload.id;

    const hotels = state.hotels;
    const idx = hotels.findIndex(findByUID, id);

    const suggested = state.suggested.hotels;
    const idx2 = suggested.findIndex(findByUID, id);

    let newState;
    // update the hotel lists
    if (idx === -1) {
      newState = update(state, {
        hotels: { $push: [action.payload] },
        suggested: {
          hotels: { $set: [...suggested.slice(0, idx2), ...suggested.slice(idx2 + 1)] },
        },
      });
    } else {
      newState = update(state, {
        hotels: {
          [idx]: { $set: action.payload },
        },
        suggested: {
          hotels: { $set: [...suggested.slice(0, idx2), ...suggested.slice(idx2 + 1)] },
        },
      });
    }
    return newState;
  },
  [HOTEL_CONTACT_ADD_SUCCESS]: (state, action) => {
    const id = action.payload.hotel.id;

    const hotels = state.hotels;
    const idx = hotels.findIndex(findByUID, id);
    if (idx === -1) {
      return update(state, {
        hotels: { $push: [action.payload.hotel] },
        selectedHotel: {
          $merge: {
            isFetching: false,
            hotel: action.payload.hotel,
          },
        },
      });
    }
    return update(state, {
      hotels: { [idx]: { $set: action.payload.hotel } },
      selectedHotel: {
        $merge: {
          isFetching: false,
          hotel: action.payload.hotel,
        },
      },
    });
  },
  [HOTEL_CONTACT_REMOVE_SUCCESS]: (state, action) => {
    const id = action.payload.hotel.id;

    const hotels = state.hotels;
    const idx = hotels.findIndex(findByUID, id);
    if (idx === -1) {
      return update(state, {
        hotels: { $push: [action.payload.hotel] },
        selectedHotel: {
          $merge: {
            isFetching: false,
            hotel: action.payload.hotel,
          },
        },
      });
    }
    return update(state, {
      hotels: {
        [idx]: { $set: action.payload.hotel },
      },
      selectedHotel: {
        $merge: {
          isFetching: false,
          hotel: action.payload.hotel,
        },
      },
    });
  },
  [HOTEL_PHOTO_REMOVE_SUCCESS]: (state, action) => {
    const id = action.payload.id;

    const photos = state.selectedHotel.hotel.photos;
    const idx2 = photos.findIndex(findById, id);
    if (idx2 === -1) {
      return state;
    }
    return update(state, {
      selectedHotel: {
        hotel: { photos: { $set: [...photos.slice(0, idx2), ...photos.slice(idx2 + 1)] } },
      },
    });
  },
  [ROOMTYPE_REMOVE_SUCCESS]: (state, action) => {
    const id = action.payload.id;
    let photos = state.selectedHotel.hotel.room_types;
    const idx2 = photos.findIndex(findById, id);
    //let temp_photos = photos.splice(idx2,1)
    if (idx2 === -1) {
      return state;
    }
    return update(state, {
      selectedHotel: {
        hotel: { room_types: { $set: [...photos.slice(0, idx2), ...photos.slice(idx2 + 1)] } },
      },
    });
  },
  [LANDMARK_REMOVE_SUCCESS]: (state, action) => {
    const id = action.payload.id;
    let landmark = state.selectedHotel.hotel.landmarks;
    let temp_landmark = landmark
    const idx2 = landmark.findIndex(findById, id);
    //temp_landmark.splice(idx2,1)
    //if (landmark.length) {
    if (idx2 === -1) {
      return state;
    }
    return update(state, {
      selectedHotel: {
        hotel: { landmarks: { $set: [...landmark.slice(0, idx2), ...landmark.slice(idx2 + 1)] } },
      },
    });
    //}

    // const landmark_data = state.hotels[0].landmarks;
    // const idx_temp = landmark_data.findIndex(findById, action.payload.id);
    // if (landmark_data.length) {
    //   if (idx_temp === -1) {
    //     return state;
    //   }
    //   return update(state, {
    //     hotels: { [0]: { landmarks: { [idx_temp]: { $set: [...landmark_data.slice(0, idx_temp), ...landmark_data.slice(idx_temp + 1)] } } } },
    //   });
    // }

  },
  [HOTEL_PHOTO_ADD_SUCCESS]: (state, action) => {
    const id = action.payload.id;
    const photos = state.selectedHotel.hotel.photos;
    const idx = photos.findIndex(findById, id);
    if (idx === -1) {
      return update(state, {
        selectedHotel: {
          hotel: { photos: { $push: [action.payload] } },
        },
      });
    }
    return update(state, {
      selectedHotel: {
        hotel: { photos: { [idx]: { $set: action.payload } } },
      },
    });
  },
  [HOTEL_PHOTO_EDIT_SUCCESS]: (state, action) => {
    const id = action.payload.id;
    const photos = state.selectedHotel.hotel.photos;
    const idx = photos.findIndex(findById, id);
    if (idx === -1) {
      return update(state, {
        selectedHotel: {
          hotel: { photos: { $push: [action.payload] } },
        },
      });
    }
    return update(state, {
      selectedHotel: {
        hotel: { photos: { [idx]: { $set: action.payload } } },
      },
    });
  },
  [HOTEL_PHOTO_SORT_SUCCESS]: (state, action) => {
    return update(state, {
      selectedHotel: {
        hotel: { $merge: action.payload },
      },
    });
  },
  [LANDMARK_EDIT_SUCCESS]: (state, action) => {
    //debugger
    const landmarks = state.selectedHotel.hotel.landmarks;
    const idx = landmarks.findIndex(findById, action.payload.id);

    return update(state, {
      selectedHotel: {
        hotel: { landmarks: { [idx]: { $set: action.payload } } },
      },
    });
    // const landmark_data = state.hotels[0].landmarks;
    // const idx2 = landmark_data.findIndex(findById, action.payload.id);
    // if (idx2 !== -1) {
    //   return update(state, {
    //     //hotels: { $push: [action.payload] },
    //     hotels: { [0]: { landmarks: { [idx2]: { $set: action.payload } } } },
    //   });
    // }
  },

  [LANDMARK_ADD_SUCCESS]: (state, action) => {
    const landmarks = state.selectedHotel.hotel.landmarks;
    const idx = landmarks.findIndex(findById, action.payload.response.id);
    if (idx === -1) {
      return update(state, {
        selectedHotel: {
          hotel: { landmarks: { $push: [action.payload.response] } },
        },
      });
    }
    // const landmark_data = state.hotels[0].landmarks;
    // if (idx === -1) {
    //   return update(state, {
    //     //hotels: { $push: [action.payload] },
    //     hotels: { [0]: { landmarks: { $push: [action.payload.response] } } },
    //   });
    // }
  },
  [ROOMTYPE_EDIT_SUCCESS]: (state, action) => {
    //debugger
    const photos = state.selectedHotel.hotel.room_types;
    const idx = photos.findIndex(findById, action.payload.id);

    return update(state, {
      selectedHotel: {
        hotel: { room_types: { [idx]: { description: { $set: action.payload.description } } } },
      },
    });
  },
  [ROOMTYPE_ADD_SUCCESS]: (state, action) => {
    return update(state, {
      selectedHotel: {
        hotel: { room_types: { $push: [action.payload] } },
      },
    });
  },
  [HOTEL_DOCUMENT_ADD_SUCCESS]: (state, action) => {
    return update(state, {
      selectedHotel: {
        hotel: { documents: { $set: action.payload } },
      },
    });
  },
  [HOTEL_DOCUMENT_DELETE_SUCCESS]: (state, action) => {
    return update(state, {
      selectedHotel: {
        hotel: { documents: { $set: action.payload } },
      },
    });
  },
  [HOTEL_DOCUMENT_UPDATE_SUCCESS]: (state, action) => {
    return update(state, {
      selectedHotel: {
        hotel: { documents: { $set: action.payload } },
      },
    });
  },
  [ROOM_PHOTO_ADD_SUCCESS]: (state, action) => {
    const room_types = state.selectedHotel.hotel.room_types;
    const idx = room_types.findIndex(findById, action.payload.hotel_room_type);

    return update(state, {
      selectedHotel: {
        hotel: { room_types: { [idx]: { room_photos: { $push: [action.payload] } } } },
      }
    })
  },

  [ROOM_PHOTO_REMOVE_SUCCESS]: (state, action) => {

    const newState = { ...state }
    const room_types = newState.selectedHotel.hotel.room_types;
    const idx = room_types.findIndex(findById, action.payload.room_type_id);
    const room_type = room_types.find(findById, action.payload.room_type_id);
    const idx2 = room_type.room_photos.findIndex(findById, action.payload.id);
    room_type.room_photos.splice(idx2, 1)

    return update(state, {
      selectedHotel: {
        hotel: { room_types: { [idx]: { room_photos: { $set: [...room_type.room_photos] } } } },
      }
    })
  },
  [HOTEL_ADD_SUCCESS]: (state, action) => {
    const id = action.payload.id;
    const hotels = state.selectedHotel.hotel;
    let idx = -1
    if (hotels.length) {
      idx = hotels.findIndex(findByUID, id);
    }
    if (idx === -1) {
      return update(state, {
        hotels: { $push: [action.payload] },
        selectedHotel: {
          $merge: {
            hotel: action.payload,
          },
        },
      });
    }
    return update(state, {
      hotels: {
        [idx]: { $set: action.payload },
      },
      selectedHotel: {
        $merge: {
          hotel: action.payload,
        },
      },
    });
  },
  [HOTEL_EDIT_SUCCESS]: (state, action) => {
    const id = action.payload.id;

    const hotels = state.hotels;
    const idx = hotels.findIndex(findByUID, id);
    if (idx === -1) {
      return update(state, {
        hotels: { $push: [action.payload] },
        selectedHotel: {
          $merge: {
            isFetching: false,
            hotel: action.payload,
          },
        },
      });
    }
    return update(state, {
      hotels: {
        [idx]: { $set: action.payload },
      },
      selectedHotel: {
        $merge: {
          isFetching: false,
          hotel: action.payload,
        },
      },
    });
  },
  [BRAND_GROUP_FETCH_SUCCESS]: (state, action) => 
    update(state, { brandGroups: { $set: (action.payload) } }),
  [PROPERTY_ACCOUNT_REGISTER_SUCCESS]: (state, action) => {
    return update(state, {
      register: {
        registered: { $set: true },
      },
    });
  },
  [PROPERTY_ACCOUNT_REGISTER_FAILURE]: (state, action) => {
    return update(state, {
      register: {
        message: { $set: action.payload.message },
      },
    });
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: false,
  needFetch: true,
  hasError: false,
  hotels: [],
  brands: [],
  brandGroups: [],
  waitlist: {
    needFetch: true,
    isFetching: false,
    onWaitlist: false,
  },
  selectedHotel: {
    isFetching: false,
    needFetch: true,
    hasError: false,
    hotel: {},
  },
  suggested: {
    isFetching: false,
    needFetch: true,
    hasError: false,
    hotels: [],
  },
  search: {
    isFetching: false,
    needFetch: false,
    hasError: false,
    hotels: [],
  },
  register: {
    message: null,
    isFetching: false,
    registered: false,
  },
};

export default function registerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// src/routes/hotels/modules/hotels.js